import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { maxLength } from 'vuelidate/lib/validators';
import { STATUS_ACTION_TYPES } from '../../values/user-requests.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { USER_REQUESTS_ROUTES } from '../../user-requests.router';

@Component({
  name: 'ed-deny-user-request'
})
export default class EdDenyUserRequestComponent extends Vue {

  /* Props */
  @Prop() readonly params: any;

  /* Data */
  public form: any = {}
  public saving: boolean = false;

  /* Computed */
  get fieldLength() {
    let remainingChars = 0;
    this.form?.note?.value?.length ? remainingChars = 256 - this.form.note.value.length : null;
    if (remainingChars > 0) return remainingChars.toString() + ' ' + this.$t('userRequests.info.noteDisclamer');
    else return []
  }

  get confirmMessage () {
    return this.params.userIds.length > 1 ? 
      this.$t('userRequests.info.denyUsersSelectedConfirm') : 
      this.$t('userRequests.info.denyUserConfirm')
  }

  /* Methods */
  private init() {
    this.form = EdFormModel([
      EdInputModel('note', '', { maxLength: maxLength(256) }, true)
    ]);
  }

  goBack() {
    this.$router.push({name: USER_REQUESTS_ROUTES.USER_REQUESTS.NAME });
  }

  async denyUser() {
    this.saving = true;
    try { 
      await this.$UserRequests.Services.respondUserRequest({
        requestId: this.params.userIds,  // TODO: Change for requestIds
        action: STATUS_ACTION_TYPES.DENY, 
        rejectionNote: this.form.note.value
      })
      this.$EdToast.create({ 
        msg: `${this.$t('userRequests.success.userDenied')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this.$UserRequests.Store.resetUserRequests();
      this.saving = false;
      if (this.params?.onDenyActionCallback) {
        this.params.onDenyActionCallback();
      }
      this.closeModal();
      if(this.$router['history'].current.name !== USER_REQUESTS_ROUTES.USER_REQUESTS.NAME)
        this.goBack()
    } catch {
      this.$EdToast.create({ 
        msg: `${this.$t('userRequests.errors.userNoDenied')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.saving = false;
      this.closeModal();
    }
  }

  closeModal() {
    this.$EdModal.closeModal();
  }

  mounted() {
    this.init()
  }
}